import React, {useState,useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';
import { UserLogin, GetUserPermissions} from '../actions/authActions';
import { TextInput, PasswordInput, Button, Container, Title, Paper, Stack, Text, Image, Box,Loader,LoadingOverlay  } from '@mantine/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt } from "@fortawesome/free-solid-svg-icons";
import logo from '../assets/images/test2.png';
import { notifyError } from "../components/Toast";


const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading: authLoading, error: authError, permissions = { loading: false, data: null, error: null } } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [username,setUsername] = useState('');
  const [password,setPassword] = useState('');

  const handleLogin = () => {
      if (!username.trim()) {
          notifyError('Debe ingresar su correo electrónico');
          return;
      }
      if (!password.trim()) {
          notifyError('Debe ingresar su contraseña');
          return;
      }
      let credentials = {
          username : username,
          password : password
      };
      dispatch(UserLogin(credentials));
  };

  const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
          handleLogin();
      }
  };

  useEffect(() => {
    if (isAuthenticated && user) {
        const userMail = user.usermail || "";
        const userRoles = user.roles || [];

        if (userMail.includes("@alumnos.uai.edu.ar") || userRoles.includes("student")) {
            notifyError('Mail institucional no válido');
        } else {
            dispatch(GetUserPermissions(user));
        }
    }
  }, [isAuthenticated, user]);

  // Removemos esta redirección ya que AppInitializer se encarga de eso
  // useEffect(() => {
  //   if(user && permissions){
  //     if (permissions.data && !permissions.loading) {
  //         navigate("/procesos-evaluacion");
  //     }
  //   }
  // }, [permissions, user, navigate]);

  return (
    <Container size={420} my={40}>
      <div className="card-base">
        <Box pos="relative">
          <LoadingOverlay
            visible={authLoading || (permissions && permissions.loading)}
            zIndex={1000}
            overlayProps={{ radius: 'sm', blur: 2 }}
            loaderProps={{ color: '#e72166', type: 'bars' }}
          />
          <Box
            style={{
                width: "200px",
                height: "200px",
                overflow: "hidden",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin:"0 auto"
            }}
          >
            <Image
              src={logo}
              alt="UAI Logo"
              style={{
                  width: "100%", 
                  height: "100%", 
              }}
            />
          </Box>
          <Title order={1} fw={400} align="center" mt={15} mb={6}>Reportes PEI</Title>
          <Text size="sm" c="dimmed" align="center" mb={20}>
            Complete su mail institucional y contraseña para ingresar
          </Text>
          <form style={{ width: '100%' }}>
            <Stack>
              <TextInput
                label="Mail"
                placeholder="Usuario@uai.edu.ar"
                rightSection={<FontAwesomeIcon icon={faAt}/>}
                required
                radius="md"
                value={username}
                onChange={(event) => setUsername(event.currentTarget.value)}
                onKeyPress={handleKeyPress}
              />
              <PasswordInput
                label="Contraseña"
                placeholder="Contraseña"
                required
                radius="md"
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
                onKeyPress={handleKeyPress}
              />
              <Button 
                onClick={()=>handleLogin()} 
                fullWidth sx={{ '&:hover': { backgroundColor: '#660000' } }}
                disabled={(authLoading || (permissions && permissions.loading)) }
                color="#e72166"
                //loading loaderProps={{ type: 'dots' }}
              >
                {(authLoading || (permissions && permissions.loading)) ? 'INGRESANDO...' : 'INGRESAR'}
              </Button>
            </Stack>
          </form>
        </Box>
      </div>
    </Container>
  );
}

export default LoginPage;

